import { AbilityBuilder, createMongoAbility } from '@casl/ability';

function defineCourseAbilities(data, courseUuid) {
    const { can, rules } = new AbilityBuilder(createMongoAbility([]));

    can('get_role', 'all', { role: data.name });

    data?.permissions?.forEach((permission) => {
        can(permission, 'Course-' + courseUuid);
    });

    return rules;
}

export { defineCourseAbilities };
